import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
    contentContainer: {
        padding: '0 44px 30px !important',
    },
    linkArrow: {
        width: '16px',
        height: '16px',
        marginRight: '6px',
        position: 'relative',
        top: '2px'
    },
    textRed: {
        color: '#e2000f',
    },
    mainTitle: {
        paddingLeft: '0px !important',
        fontSize: '24px',
        fontWeight: 'bold',
        margin: '8px 0 24px'
    },
    linkContainer: {
        textAlign: 'left',
        fontFamily: 'myriad-pro, Myriad Pro',
        fontSize: '18px',
        fontWeight: 600,
        cursor:'pointer',
        marginTop: '22px'
    },
    link: {
        color: '#000',
        textDecoration: 'none',
    }
}));